import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/styles";
import inflection from "inflection";
import React, { useState } from "react";
import { Confirm, useTranslate } from "react-admin";
import {
  TenantRegistrationApiFactory,
  TenantRegistrationDto,
  TenantRegistrationStatus,
} from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";

interface Props {
  label: string;
  icon: JSX.Element;
  record: TenantRegistrationDto;
  classes: ClassNameMap<"approve">;
  resource?: string;
  confirmTitle?: string;
  confirmContent?: string;
  onClick?: (event: React.MouseEvent) => void;
  onSuccess?: () => void;
}

export const ApproveDeactivationMenuItem = ({
  label,
  record,
  resource,
  confirmTitle,
  confirmContent,
  onClick,
  icon,
  classes,
  onSuccess,
  ...rest
}: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const axios = useAxiosInstance();
  const translate = useTranslate();

  if (!confirmTitle) {
    confirmTitle = "resources.master-tenant-registrations.labels.approve_title";
  }

  if (!confirmContent) {
    confirmContent =
      "resources.master-tenant-registrations.labels.aproveDeactivation_content";
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  const handleDeactivate = () => {
    if (!axios) {
      return;
    }

    setLoading(true);
    TenantRegistrationApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppTenantregistrationApproveordenypendingrequestPost({
        id: `${record.id}`,
        status: TenantRegistrationStatus.Deactivated,
      })
      .then(() => {
        if (onSuccess) onSuccess();
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}>
        <ListItemIcon className={classes.approve}>{icon}</ListItemIcon>
        <ListItemText>{translate(label, { _: label })}</ListItemText>
      </MenuItem>
      <Confirm
        isOpen={isConfirmOpen}
        loading={loading}
        title={confirmTitle}
        content={confirmContent}
        translateOptions={{
          name: inflection.singularize(
            translate(`resources.${resource}.forcedCaseName`, {
              smart_count: 1,
              _: inflection.humanize(
                translate(`resources.${resource}.name`, {
                  smart_count: 1,
                  _: inflection.singularize(resource!),
                }),
                true
              ),
            })
          ),
          id: record!.id,
        }}
        onConfirm={handleDeactivate}
        onClose={handleDialogClose}
      />
    </>
  );
};
